import { BASE_URL,  POLICIES } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ApiResponse } from "./auth";
import { IPolicy, IPolicyInput } from "models/policy";


export async function getPolicies(params: string = "") : Promise<ApiResponse<IPolicy[]>> {
  const response = await axios.get(BASE_URL + POLICIES + params);
  return response.data;
}


export async function addPolicy(data: IPolicyInput) {
  const response = await axios.post(BASE_URL + POLICIES, data);
  return response.data;
}
export async function editPolicy(data: IPolicyInput, id: string) {
  const response = await axios.put(BASE_URL + POLICIES + id , data);
  return response.data;
}

export async function deletePolicy(id: string) {
  const response = await axios.delete(BASE_URL + POLICIES + id);
  return response.data;
}


export const PoliciesCells: HeadCell[] = [
  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "Title",
    
  },
  {
    id: "content",
    numeric: false,
    disablePadding: false,
    label: "Content",
  },
  {
    id: "type",
    numeric: false,
    disablePadding: false,
    label: "Type",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
  },
];